import { useCallback } from 'react';
import {
  Typography,
  FormControlLabel,
  makeStyles,
} from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import { setComparisonMode } from '../../../../../redux_store';
import ElegantSwitch from '../../../../Shared/ElegantSwitch';

const useStyles = makeStyles((theme) => ({
  controlGroup: {
    flex: '0 0 auto',
    paddingBottom: theme.spacing(0),
    borderBottom: 'none',
    marginBottom: theme.spacing(0),

    [theme.breakpoints.up('lg')]: {
      paddingBottom: theme.spacing(2),
      borderBottom: 'none',
      marginBottom: theme.spacing(2),
    },
  },
  sectionTitle: {
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: 1.5,
    textTransform: 'uppercase',
    color: '#9196A6',
    marginBottom: theme.spacing(1.5),
  },
  toggleLabel: {
    fontSize: 14,
    color: '#4A5568',
  },
}));

const ComparisonModeToggle = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { en: { populationHealth } } = useSelector((state) => state.i18n);
  const { isComparisonMode } = useSelector((state) => state.populationHealth);

  const handleToggle = useCallback((e) => {
    dispatch(setComparisonMode(e.target.checked));
  }, [dispatch]);

  const labelText = isComparisonMode
    ? (populationHealth?.baselineVsFollowup || 'Baseline vs Follow-up')
    : (populationHealth?.singleTimePoint || 'Single Time Point');

  return (
    <div className={classes.controlGroup}>
      <Typography className={classes.sectionTitle}>
        {populationHealth?.comparisonMode || 'Comparison Mode'}
      </Typography>
      <FormControlLabel
        control={
          <ElegantSwitch
            checked={isComparisonMode}
            onChange={handleToggle}
          />
        }
        label={
          <Typography className={classes.toggleLabel}>
            {labelText}
          </Typography>
        }
      />
    </div>
  );
};

export default ComparisonModeToggle;
